/* eslint-disable */
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

// MUI
import {
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Typography,
} from '@mui/material';

// Types
import { ModuleCardType } from '@/@types/common';
import { useNavigate } from 'react-router-dom';

interface ModuleCardProps {
  module: ModuleCardType;
}

const ModuleCard = (props: ModuleCardProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  
  const { module } = props;
  const { titleTtoken, descriptionTtoken, imageSrc, path, external, icon } =
    module;

  const handleNavigate = () =>{
    navigate(path)
  }

  return (
    <Card sx={{ height: '100%' }}>
      <CardActionArea onClick={handleNavigate} sx={{ height: '100%' }}>
        <CardMedia
          component="img"
          height="170px"
          image={imageSrc}
          alt="green iguana"
        />
        <CardContent>
          <Typography gutterBottom variant="h5" component="div">
            {t(titleTtoken)}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {t(descriptionTtoken)}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default ModuleCard;
